import { Component, OnInit } from '@angular/core';
import { Pricelist } from '../../../model/pricelist';
import { MatTableDataSource } from '@angular/material';
import { DataService } from 'src/app/service/data.service';
import { TranslationService } from 'src/app/service/translate.service';
@Component({
  selector: 'app-pricelist',
  templateUrl: './pricelist.component.html',
  styleUrls: ['./pricelist.component.css']
})
export class PricelistComponent implements OnInit {
  public dataSource = new MatTableDataSource<Pricelist>();
  displayedColumns = ['description', 'price'];
  constructor(
    private dataService: DataService,
    private translateService: TranslationService) {

  }

  ngOnInit() {
    this.getPriceList(this.translateService.language);
    this.translateService.currentLang.subscribe(lang => this.getPriceList(lang));
  }

  getPriceList(lang: string) {
    this.dataService
    .getPriceList(lang)
    .subscribe(data => this.dataSource.data = data as Pricelist[]);
  }

}
